<template>
    <SettingsWrapper title="Resource pool settings" section="General">
        <div class="coming-soon-wrap">
            <v-sheet class="coming-soon-panel" color="grey lighten-4" rounded>
                <v-icon size="42" color="grey darken-1">mdi-timer-sand</v-icon>
                <div class="coming-soon-title">Coming soon</div>
                <div class="coming-soon-subtitle">This section is under construction.</div>
            </v-sheet>
        </div>
    </SettingsWrapper>
</template>

<script>
import SettingsWrapper from '@/components/SettingsWrapper.vue'

export default {
    name: 'PoolSettingsGeneral',
    components: { SettingsWrapper }
}
</script>

<style scoped>
.coming-soon-wrap {
    min-height: 62vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.coming-soon-panel {
    width: min(620px, 100%);
    padding: 40px 32px;
    text-align: center;
    border: 1px solid rgba(158, 158, 158, 0.45);
}

.coming-soon-title {
    margin-top: 14px;
    font-size: 1.5rem;
    font-weight: 700;
    color: #616161;
}

.coming-soon-subtitle {
    margin-top: 10px;
    font-size: 1rem;
    color: #757575;
}
</style>
